import {default as debug} from 'debug';


export default (filename) => {
    return debug(`adi-civil:${filename}`.replace('src/', ''));
}



// WEBPACK FOOTER //
// ./src/util/debug.js